import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailrecordableComponent } from './emailrecordable.component';
import { FormsModule } from '@angular/forms';
import { ModalformModule } from '../../modalform/modalform.module';
import { EditorModule } from 'primeng/editor';



@NgModule({
    imports: [
        CommonModule,
        EditorModule,
        FormsModule,
        ModalformModule,
        EmailrecordableComponent
    ],
    exports: [EmailrecordableComponent]
})
export class EmailrecordableModule { }
